import React from "react";

const ResponseLoding = () => {
  return (
    <>
      <div className=" successful_preview_transprant_body ">
        <div className=" p-2 successful_preview_container shadow">
          {/* <img src="/images/Ellipse 208.svg" alt="" /> */}
          <img
            className="prereadLoader"
            src="/gift/document_scanning.gif"
            alt=""
          />
          <span className=" mb-4 mt-2 successfully_message">Publishing...</span>
          {/* <Link to="/PublishedHomeworkPreRead"> */}
          {/* <button className="successfull_okay_btn">Okay</button> */}
          {/* </Link> */}
        </div>
      </div>
    </>
  );
};

export default ResponseLoding;
